export class DomainUserUtil {
  public static isDomainUser(userName: string): boolean {
    return !!userName?.includes('\\');
  }
}